module.exports = __webpack_public_path__ + "static/media/Soldering.b046e799.jpg";